/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportMyFxBookAccountsCommand } from '../../models/import-my-fx-book-accounts-command';
import { SuccessApiResponse } from '../../models/success-api-response';

export interface ImportMyFxBookAccountsAsync$Plain$Params {
  command?: ImportMyFxBookAccountsCommand;
}

export function importMyFxBookAccountsAsync$Plain(http: HttpClient, rootUrl: string, params?: ImportMyFxBookAccountsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessApiResponse>> {
  const rb = new RequestBuilder(rootUrl, importMyFxBookAccountsAsync$Plain.PATH, 'post');
  if (params) {
    rb.query('command', params.command, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessApiResponse>;
    })
  );
}

importMyFxBookAccountsAsync$Plain.PATH = '/api/my-fx-book/accounts';
